import {BaseComponent} from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import styled from 'styled-components';
import {HBox, VBox} from '../../../components/Box';
import {Card} from '../../../components/Card';
import {ParentToSub} from '../../../components/Icon';
import {InvoiceStructureSelection} from "./InvoiceStructureSelection";
import {selectInvoice} from "../selectors";
import {RelatedInvoiceCard} from "./RelatedInvoiceCard";

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
  .sub-company {
    .delete {
      opacity: 0;
    }
    &:hover {
      .delete {
        opacity: 1;
      }
    }
  }

  .box.sub {
    margin-left: 20px;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class InvoiceStructureCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get invoice() {
    return this.props.invoice;
  }

  onRelatedInvoiceClick(url) {
    this.props.onRelatedInvoiceClick(url);
  }

  render() {
    const invoice = this.props.invoice;
    return (
      <Card className="company-info-card info-card data">
        <Container>
          <HBox>
            <h2>{this.lbl('invoice.structure.title')}</h2>
          </HBox>
          <VBox>
            <InvoiceStructureSelection invoice={invoice} relation="parent" />
            {this.invoice.parentInvoices?.map(i => (
              <HBox className="sub-company" left vCenter key={i.id}>
                <RelatedInvoiceCard invoice={i} onClick={this.onRelatedInvoiceClick.bind(this)} />
              </HBox>
            ))}
            <HBox left vCenter>
            </HBox>
            <VBox left vCenter className="sub">
              <InvoiceStructureSelection invoice={invoice} relation="child" />
              {this.invoice.subInvoices?.map(i => (
                <HBox className="sub-company" left key={i.id} vCenter>
                  <ParentToSub />
                  <RelatedInvoiceCard invoice={i} onClick={this.onRelatedInvoiceClick.bind(this)} />
                </HBox>
              ))}
            </VBox>
          </VBox>
        </Container>
      </Card>
    );
  }
}

InvoiceStructureCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
  invoice: selectInvoice(),
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InvoiceStructureCard = compose(
  withConnect,
  withRouter,
)(InvoiceStructureCardComp);
